class SalesApi {
  constructor (agaveAdapter) {
    this.agaveAdapter = agaveAdapter
  }

  // Sales-only. Returns the rep's assigned facilities, decorated with wallet
  // balances. Scoped server-side by the user's Freshsales `crmId`.
  getAssignedClientsWithBalance () {
    return this.agaveAdapter.get('sales/clients')
  }

  // Returns every provisioned facility in the given market.
  getClientsByMarket ({ market }) {
    return this.agaveAdapter.get('sales/clients-by-market', { market })
  }

  // Sales-only. Returns the distinct markets the rep's assigned facilities live under.
  getMarkets () {
    return this.agaveAdapter.get('sales/markets')
  }
}

module.exports = SalesApi
